import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  email: string;
};

const [useAddSpaceEmailDomain, addSpaceEmailDomain] = createAsyncAction(
  "spaces/addSpaceEmailDomain",
  async ({ spaceId, email }: Args) => {
    return await API.call<number>({
      endpoint: `spaces/${spaceId}/domains`,
      method: "POST",
      entity: API.Entity.space,
      data: { email },
    });
  }
);

export default useAddSpaceEmailDomain;
export { addSpaceEmailDomain };
